import { UseQueryOptions } from 'react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from 'hooks/useQuery';
import QueryKeys from './keys';
import { SMS } from 'domains/content/types';

/**
 * Hook to fetch all SMS content
 *
 * @param reactQueryOptions Additional react-query options
 * @returns Query result with array of SMS content items
 */
const useSmses = (reactQueryOptions?: UseQueryOptions<SMS[], Error>) =>
    useQuery<SMS[]>(QueryKeys.SMSES, CuredApiPaths.SMS, reactQueryOptions);

export default useSmses;
